import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton, SkeletonGroup } from '@/components/ui/skeleton'

/** Loading state for the customer page, in the shape of the loaded page. */
export function CustomerDetailSkeleton() {
  return (
    <SkeletonGroup aria-label="Loading customer" className="flex flex-col gap-6">
      <div className="flex items-center gap-3">
        <Skeleton className="h-8 w-72" />
        <Skeleton className="h-6 w-24 rounded-full" />
        <Skeleton className="h-7 w-24" />
      </div>

      <div className="flex items-start gap-6">
        <div className="flex w-56 shrink-0 flex-col gap-4">
          <div className="flex flex-col gap-1">
            {Array.from({ length: 8 }).map((_, index) => (
              <Skeleton key={index} className="h-9 w-full rounded-lg" />
            ))}
          </div>
          <div className="flex flex-col gap-3">
            {Array.from({ length: 4 }).map((_, index) => (
              <Skeleton key={index} className="h-9 w-full" />
            ))}
          </div>
        </div>

        <div className="flex max-w-7xl min-w-0 flex-1 flex-col gap-6">
          <Card>
            <CardHeader className="gap-2">
              <CardTitle>
                <Skeleton className="h-5 w-40" />
              </CardTitle>
              <Skeleton className="h-4 w-56" />
            </CardHeader>
            <CardContent className="flex flex-col gap-3">
              {Array.from({ length: 5 }).map((_, index) => (
                <Skeleton key={index} className="h-8 w-full" />
              ))}
            </CardContent>
          </Card>
        </div>
      </div>
    </SkeletonGroup>
  )
}
